import { TextField } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';

const SelectBox = (props) => {
    const { List, ...rest } = props;

    let insertEmpty = rest.insertEmpty;
    if (insertEmpty === undefined) {
        insertEmpty = true;
    }

    return (
        <TextField select size="small" variant="outlined" fullWidth {...rest}>
            {insertEmpty && (
                <MenuItem value="">
                    <em>None</em>
                </MenuItem>
            )}

            {List?.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                    {option.name}
                </MenuItem>
            ))}
        </TextField>
    );
};

export default SelectBox;
